/* eslint-disable */ import { memoEval, replaceEntityRecipesComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const kickPlateBoltHolesComponents = [
    attachComponent.withComponent(replaceEntityRecipesComponent, 'default', true).withEntity('KickPlateBoltHoles').attach(memoEval((self)=>[
            self.$kickPlateCountersinkHolesRecipes
        ], ($kickPlateCountersinkHolesRecipes)=>({
            recipes: $kickPlateCountersinkHolesRecipes,
            keepChildren: true
        })))
];

//# sourceMappingURL=kick-plate-bolt-holes.js.map